import { Link, useNavigate } from "react-router-dom";
import { ChevronRight, ArrowLeft } from "lucide-react";

export interface BreadcrumbItem {
  name: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

export default function Breadcrumbs({ items, className = "" }: BreadcrumbsProps) {
  const navigate = useNavigate();

  return (
    <nav
      className={`flex items-center ${className}`}
      aria-label="Breadcrumb"
    >
      {/* Mobile: simple back button */}
      <button
        onClick={() => navigate(-1)}
        className="md:hidden inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
        type="button"
      >
        <ArrowLeft className="w-4 h-4" />
        Back
      </button>

      {/* Desktop: full breadcrumb trail */}
      <ol className="hidden md:flex items-center flex-wrap gap-1.5 text-sm text-slate-500">
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-1.5">
            {idx > 0 && (
              <ChevronRight className="w-3.5 h-3.5 text-slate-400 shrink-0" />
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {item.name}
              </Link>
            ) : (
              <span className="text-slate-800 font-medium whitespace-nowrap">
                {item.name}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}